import { render, staticRenderFns } from "./daodu.vue?vue&type=template&id=0c0a66fa&scoped=true"
import script from "./daodu.vue?vue&type=script&lang=js"
export * from "./daodu.vue?vue&type=script&lang=js"
import style0 from "./daodu.vue?vue&type=style&index=0&id=0c0a66fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a66fa",
  null
  
)

export default component.exports